<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">项目招标控制价审批</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回项目详情</a>
    </div>
    <div class="form-content">
      <el-form ref="form" label-width="140px" class="form" style="margin-bottom:-25px;">
        <el-form-item label="审批类型">
          <el-radio-group :disabled="hasApplyId" v-model="objectType" class="type-radio-type">
            <el-radio-button label="default">通用审批</el-radio-button>
            <el-radio-button label="ys">原水审批</el-radio-button>
            <el-radio-button label="ybyh">一户一表</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <create-invite1 :projectArr="projectArr" :teamArr="teamArr" :projectId="projectId" v-if="objectType=='default'"></create-invite1>
      <create-invite2 :projectArr="projectArr" :teamArr="teamArr" :projectId="projectId" v-if="objectType=='ys'"></create-invite2>
      <create-invite3 :projectArr="projectArr" :teamArr="teamArr" :projectId="projectId" v-if="objectType=='ybyh'"></create-invite3>
    </div>

  </div>
</template>

<script>
  import CreateInvite1 from './createInvite_1'
  import CreateInvite2 from './createInvite_2'
  import CreateInvite3 from './createInvite_3'
  export default {
    computed: {},
    data() {
      return {
        projectId: "",
        objectType: "default",
        teamArr: [],
        projectArr: [],
        hasApplyId: '',
      }
    },
    mounted() {
      // 获取项目组
      this.getTeam()
      // 获取项目列表
      this.getProject()
    },
    created() {
      console.log(this.$route.params)
      this.hasApplyId = this.$route.params.applyId ? true : false
      this.projectId = this.$route.params.projectId
      if (this.hasApplyId) {
        ajax.get('/gc/project/invite/info/' + this.$route.params.applyId, '', (res) => {
          console.log(res.vo.type)
          switch (res.vo.type) {
            case "0":
              this.objectType = 'default'
              break;
            case "1":
              this.objectType = 'ys'
              break;
            case "2":
              this.objectType = 'ybyh'
              break;
          }
        })
      }
    },
    components: {
      CreateInvite1,
      CreateInvite2,
      CreateInvite3,
    },
    methods: {
      // 获取项目组
      getTeam() {
        ajax.post('/gc/project/team/list', '', (res) => {
          this.teamArr = res.vo.array
        })
      },
      // 获取项目列表
      getProject() {
        ajax.get('/gc/project/list', {
          depId: ''
        }, (res) => {
          this.projectArr = res.vo.array
        })
      }
    },
    watch: {
      "$route"() {
        this.hasApplyId = this.$route.params.applyId ? true : false
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createInvite.vue